import React from 'react';
import { FloatingPortal } from '@floating-ui/react';
import { Toaster } from 'react-hot-toast';
import * as styles from './Toast.module.scss';

export const ToastContainer = () => {
  return (
    // By wrapping with FloatingPortal (a library for React Portal), we render the toast container outside of the
    // parent component's DOM hierarchy. This means the toast isn't obstructed by inherited styles from the parent
    // For example, a <ToastContainer> can be nested inside <StudyListToolbar> and the toast won't be hindered by
    // the restrictive z-index of the <StudyListToolbar>.
    // Specifying id="reactToastContainer" portals the toast specifically into our existing div defined in HAML,
    // which is useful for testing in Rspec.

    // Unfortunately react-hot-toast is not accessible by default
    // On page load we need to render a container with aria - live and role = "status"
    // The screen reader will read out it's contents whenever new content is inserted

    <FloatingPortal id="reactToastContainer">
      <div aria-live="polite" role="status" className={styles.toastContainer}>
        <Toaster reverseOrder={false} />
      </div>
    </FloatingPortal>
  );
};
